import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { breakpoints } from 'stylesheet';

export const Styles = {
  SearchResultsList: styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: ${defaultTheme.spacing(4)};

    @media (min-width: ${breakpoints.medium}) {
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: ${defaultTheme.spacing(5)};
      grid-column-gap: ${defaultTheme.spacing(10)};
    }
  `,
  LoadMoreArea: styled.div`
    width: 100%;
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};
